import React, { PropTypes } from 'react';
import { hashHistory, Link } from 'react-router';
import ReactDOM from 'react-dom';
import { Carousel, Icon, Spin, Button, message, Select, Modal, Input } from 'antd';
import Slider from 'react-slick'
import PayModal from "../share/PayModal";

const Option = Select.Option;

import ArchiveTemplateView from '../share/ArchiveTemplateView';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';

export default class ArchiveBookStudentDetailPage extends React.Component {
  constructor(props) {
    super(props);
    // set state
    let semester = props.location.query.semester;
    let paid_status = this.toolPaidStatus(semester);

    this.state = {
      role: CurrentRoleStore.getCurrentRole(),
      pageList: [],
      templateContainerView: {
        width: 550,
        height: 0
      },
      exhibitImageView: {
        width: 60,
        height: 0
      },
      loading: false,
      showArray: [],
      templateKey: props.location.query.templateKey ? props.location.query.templateKey : 0,
      classId: props.params.classId,
      studentId: props.params.studentId,
      studentName: props.location.query.studentName,
      schoolId:null,
      semester,
      semesters: [],
      slickCount: 7,
      paid_status,
      showPayModal: false,
      archiveBookModal: false
    };
    // bind this
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
    this.changeHandler = this.changeHandler.bind(this)

    this.getReviewedPageCount = this.getReviewedPageCount.bind(this)
    this.getPageCount = this.getPageCount.bind(this)
    this.confirmPrint = this.confirmPrint.bind(this)
    this.selectSemester = this.selectSemester.bind(this)

    this.forceUpdate = this.forceUpdate.bind(this)
  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onCurrentRoleChange);
    this.setState({
      loading: true
    })

    DataService.getOneStudentInfo(this.state.studentId).then((res) => {
      let semesters = SharedTools.getAllSemesters(SharedTools.getCurrentSemester(), SharedTools.getCurrentSemester(res.created_at), res.archive_semester_count);

      // 设置默认学期为该年份第一个学期
      let currentSemester = this.state.semester, semester;
      if (res.archive_semester_count == 1) {
        semester = String(currentSemester).substring(0, 4) + '1';
      } else {
        semester = currentSemester;
      }
      let schoolId = res.class_record.school_id

      this.setState({
        semesters,
        semester,
        schoolId,
      },() => {
        this.getArchives();
      })
    }).catch((error) => {
      console.log(error)
    })
  }

  toolPaidStatus(semester) {
    let role = CurrentRoleStore.getCurrentRole();

    let year = Number(String(semester).substring(0, 4));
    let currentTime = (role.associatObj.pay_slice == 'semester' ? semester : role.associatObj.pay_slice == 'term'? year : null);

    let paid_status = true;
    if (role.roleName == 'parent') {
      if (currentTime){
        let item = role.associatObj.paid_semesters.find(semester => {
          return String(currentTime).indexOf(String(semester)) >= 0 ? true : false
        })
        paid_status = item ? true : false
      }
    }

    return paid_status
  }

  getArchives() {
    DataService.getArchives(this.state.classId, this.state.semester).then((res) => {
      let quality = res.quality, showArray = [];
      var optionsListNew = new Array(quality == 'hardback' ? res.page_count : res.page_count+1)
      let showCount = (optionsListNew.length % 2 == 0 ? parseInt(optionsListNew.length / 2) : (parseInt(optionsListNew.length / 2) + 1));

      for (let i = 0; i < optionsListNew.length; i++) {
        if (quality == 'hardback') {
          optionsListNew[i] = {
            page_number: i + 1
          }
        } else {
          optionsListNew[i] = {
            page_number: i
          }
        }
      }

      for (let i = 0; i < showCount + 1; i++) {
        showArray[i] = {
          index: i
        }
      }
      //获取模板答案
      DataService.getStudentArchivesContent(this.state.studentId, this.state.semester).then((res) => {
        let publishedPageNum = 0;
        let frontPage = res.find(function (page) {
          return page.page_type == "front_cover"
        })
        let pages = res.filter(function (page) {
          return page.page_type == "inside";
        });
        let pageArray = [], templateContainerView = this.state.templateContainerView, exhibitImageView = this.state.exhibitImageView;
        pageArray.push(frontPage);
        pageArray = pageArray.concat(pages);
        pageArray.forEach(function (page) {
          if (!page.is_published) {
            page.status = "未提交"
          } else if (page.is_published) {
            if (page.page_type != 'front_cover') {
              publishedPageNum++;
            }
            if (page.is_reviewed) {
              page.status = "已审核"
            } else if (page.template.need_review) {
              page.status = "已提交-需管理员审核"
            } else {
              page.status = "已提交"
            }
          }

          // page.author_type = '"' + page.author_type + '"';
          if (page.page_type == 'inside') {
            if (quality == 'hardback') {
              optionsListNew[page.page_number - 1] = page;
            } else {
              optionsListNew[page.page_number] = page;
            }
          }

          let ratio = templateContainerView.width / page.template.width;
          templateContainerView.height = ratio * page.template.height;
          exhibitImageView.height = exhibitImageView.width / page.template.width * page.template.height;

        })

        this.setState({
          pageList: optionsListNew,
          showArray: showArray,
          frontPage: frontPage,
          publishedPageNum: publishedPageNum,
          templateContainerView: templateContainerView,
          exhibitImageView: exhibitImageView,
          loading: false,
        })
        let templateKey = this.state.templateKey, slickCount = this.state.slickCount;
        let nextCount = parseInt(templateKey / slickCount);
        for(let i = 0; i < nextCount ; i ++) {
          this.next()
        }
      }).catch((error) => {
        console.log(error)

      })

      this.setState({
        archive: res,
      })
    }).catch((error) => {
      console.log(error)
      if (error && error.errorMessage.errors[0].code == 41) {
        message.error('未找到相应的成长档案');
        this.setState({
          loading: false,
          pageList: [],
          showArray: [],
          frontPage: undefined
        })
      }
    })
  }

  next() {
    this.refs.slider.slickNext()
  }

  previous() {
    this.refs.slider.slickPrev()
  }

  selectTemplate(key) {
    if (key != this.state.templateKey) {
      this.setState({
        templateKey: key,
      })
    }
  }

  reviewPageContent(page) {
    DataService.reviewPageContent(page.page_content_id).then((res) => {
      message.success('审核通过');
      if (page.page_type == "front_cover") {
        this.state.frontPage.is_reviewed = true;
        this.setState({
          frontPage: this.state.frontPage
        })
      } else {
        let newPage = this.state.pageList.find((result) => result.id == page.id);
        newPage.is_reviewed = true;
        this.setState({
          pageList: this.state.pageList
        })
      }
    }).catch((error) => {
      message.error('审核失败，请重新审核');
      console.log(error)
    })

  }

  changeHandler(number) {
    this.refs.slider.slickGoTo(number)
  }

  getReviewedPageCount() {
    return this.state.pageList.filter((page) => page.is_reviewed).length;
  }

  getPageCount() {
    let count = this.state.pageList.filter((page) => page.template).length;
    return ((this.state.archive && this.state.archive.quality == 'hardback') ? count : count - 1);
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      let paid_status = this.toolPaidStatus(value);
      this.props.location.query.semester = value;
      hashHistory.replace(this.props.location);

      this.setState({
        semester: value,
        paid_status
      }, () => {
        this.getArchives();
      })
    }
  }

  goEditPage(page) {
    this.props.location.query.templateKey = this.state.templateKey;
    hashHistory.replace(this.props.location);

    if (page.template.t_type == 'story') {
      hashHistory.push(`archive/record/story/?studentIds=[${this.state.studentId}]&pageId=${page.id}&templateId=${page.template.id}&archiveId=${this.state.archive.id}&classId=${this.state.classId}&semester=${this.state.semester}${page.page_content_id ? '&pageContentId=' + page.page_content_id : ''}`);
    } else {
      hashHistory.push(`archive/record/edit/?studentIds=[${this.state.studentId}]&pageId=${page.id}&templateId=${page.template.id}&archiveId=${this.state.archive.id}${page.is_published ? '&status=changeable' : ''}`)
    }
  }

  confirmPrint() {
    let reviewedPageCount = this.getReviewedPageCount(), pageCount = this.getPageCount();
    let unCompletePage = pageCount - (this.state.pageList.filter((page) => (page.is_published && page.template))).length+(this.state.archive && this.state.archive.quality == 'hardback'?0:1);
    // if (unCompletePage >0 || !this.state.frontPage.is_published) {
    //   Modal.warning({
    //     title: '无法获取电子册',
    //     content: '需完成所有内容后，方可获取',
    //     okText: '我知道了',
    //   })
    // } else {
      this.setState({
        archiveBookModal: true
      })
    // }
  }

  forceUpdate(){
    let {studentId,semester} = this.state
    let data = {
      student_id:studentId,
      semester,
    }
    DataService.updateBookOrders(data).then((res)=>{
      message.success("更新成功！")
    }).catch((error)=>{
      console.log(error)
      switch(error.errorMessage.errors[0].code){
        case 11:
          message.error("更新失败，缺少必要参数！")
          break;
        case 42:
          message.error("更新失败，学生姓名未找到！")
          break;
        case 43:
          message.error("更新失败，学生未在该学校！")
          break;
        case 71:
          message.error("更新服务器响应失败！")
          break;
      }
    })
  }

  callbackPayModal() {
    this.setState({
      showPayModal: false
    })
  }

  createBookOrders() {
    let status = this.checkEmail(this.state.email);
    if (status) {
      let data = {
        semester: this.state.semester,
        mail_address: this.state.email,
        student_id: this.state.studentId,
        school_id:this.state.schoolId,
      }
      if (this.state.role.roleName == 'teacher') {
        data.class_record_id = this.state.classId;
      }

      DataService.sendBookToArchiveMail(data).then((res) => {
        Modal.success({
          title: '电子册制作中',
          content: `${this.state.studentName}宝贝的电子册将会在5个工作日内发送到您${this.state.email}的邮箱，请注意查收。`,
        });
        this.setState({
          email: '',
          archiveBookModal: false
        })
      }).catch((error) => {
        console.log(error)
        if (error && error.errorMessage.errors[0].code == 51) {
          Modal.success({
            title: '电子册已成功',
            content: `${this.state.studentName}宝贝的电子册已发送到您${this.state.email}的邮箱，请注意查收。`,
          });
        }
        else{
          Modal.error({
            title: '电子册获取失败',
            content: `暂未找到电子册，您可以微信添加嘟嘟助手(ddycj2015)！`,
          });
        }
        this.setState({
          email: '',
          archiveBookModal: false
        })
      });
    }
  }

  checkEmail(email) {
    var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
    if (email === "") { //输入不能为空
      message.error('填写的邮箱不能为空')
      return false;
    } else if (!reg.test(email)) { //正则验证不通过，格式不对
      message.error('邮箱格式错误，请重新填写')
      return false;
    } else {
      return true;
    }
  }

  _renderArchiveBookModal() {
    let semesterToString = '';
    let semesterArray = this.state.semesters.filter((semester) => (semester.semester == Number(this.state.semester)));
    if (semesterArray.length > 0) {
      semesterToString = semesterArray[0].semesterToString;
    }

    return <Modal
      className="archive-book-modal"
      footer={[<Button key="back" onClick={this.createBookOrders.bind(this)} type="primary">提交</Button>]}
      title="获取电子册"
      onCancel={() => { this.setState({ archiveBookModal: false})}}
      visible={this.state.archiveBookModal}
      maskClosable={false}
    >
      <div className="edit-name">
        <Input addonBefore={<span><span className="red">*</span>邮箱</span>} onChange={(e) => this.setState({email: e.target.value})} data-type="name" />
        <p>我们将在5个工作日内将{semesterToString}的电子册发送至您的邮箱</p>
      </div>
    </Modal>
  }

  _showArchiveTemplateView() {
    let key = this.state.templateKey;
    let role = this.state.role;
    if (key == '0' || key == 0) {
      return(
        <Spin spinning={this.state.loading}>
          <div className="archive-template-container">
            <div className="page-list-view clearfix">
              {(role.roleName == 'parent' && this.state.frontPage && this.state.frontPage.author_type != 'parent') ? '' : <div className="edit-box box-left" onClick={this.goEditPage.bind(this, this.state.frontPage)}>
                <div className="edit-icon"></div>
                <div>编辑</div>
              </div> }
              <ArchiveTemplateView template={this.state.frontPage ? this.state.frontPage.template : ''} templateContainerView={this.state.templateContainerView}/>
              <div className="page-info info-left">封面-{this.state.frontPage ? (!this.state.frontPage.is_published ? '未提交' : (this.state.frontPage.is_reviewed ? '已审核' : '已提交未审核')) : ''}</div>
              {(this.state.frontPage && this.state.frontPage.is_published && !this.state.frontPage.is_reviewed) ? <Button className="review-btn info-left" type="primary" onClick={this.reviewPageContent.bind(this, this.state.frontPage)}>审核通过</Button> : ''}
            </div>
          </div>
        </Spin>
      )
    } else {
      let pageLeft = this.state.pageList[(key - 1) * 2], pageRight = this.state.pageList[(key - 1) * 2 + 1];
      let templateContainerStyle = {
        width: this.state.templateContainerView.width,
        height: this.state.templateContainerView.height,
        lineHeight: this.state.templateContainerView.height + 'px',
        fontSize: '20px'
      }
      return(
        <Spin spinning={this.state.loading}>
          <div className="archive-template-container">
            <div className="page-list-view clearfix">
              {(pageLeft && pageLeft.template && !(role.roleName == 'parent' && pageLeft.author_type != 'parent')) ? <div className="edit-box box-left"  onClick={this.goEditPage.bind(this, pageLeft)}>
                <div className="edit-icon"></div>
                <div>编辑</div>
              </div> : ''}
              {(pageLeft && pageLeft.template) ? <div className="page-info info-left">第{pageLeft.page_number}页-{pageLeft.template ? (!pageLeft.is_published ? '未提交' : (pageLeft.is_reviewed ? '已审核' : '已提交未审核')) : ''}</div> : ''}
              {(pageLeft && pageLeft.is_published && !pageLeft.is_reviewed) ? <Button className="review-btn info-left" type="primary" onClick={this.reviewPageContent.bind(this, pageLeft)}>审核通过</Button> : ''}
              {(pageLeft && pageLeft.template) ? <ArchiveTemplateView template={pageLeft.template} templateContainerView={this.state.templateContainerView}/> : <div className="no-template" style={templateContainerStyle}>{(this.state.archive.quality == 'paperback' && key == 1) ? '扉页' : '未添加模版'}</div>}

              {(pageRight) ? ((pageRight.template) ? <ArchiveTemplateView template={pageRight.template} templateContainerView={this.state.templateContainerView}/> : <div className="no-template page-right" style={templateContainerStyle}>未添加模版</div>) : ''}
              {(pageRight && pageRight.template && !(role.roleName == 'parent' && pageRight.author_type != 'parent')) ? <div className="edit-box box-right"  onClick={this.goEditPage.bind(this, pageRight)}>
                <div className="edit-icon"></div>
                <div>编辑</div>
              </div> : ''}
              {(pageRight && pageRight.template) ? <div className="page-info info-right">第{pageRight.page_number}页-{pageRight.template ? (!pageRight.is_published ? '未提交' : (pageRight.is_reviewed ? '已审核' : '已提交未审核')) : ''}</div> : ''}
              {(pageRight && pageRight.is_published && !pageRight.is_reviewed) ? <Button className="review-btn info-right" type="primary" onClick={this.reviewPageContent.bind(this, pageRight)}>审核通过</Button> : ''}
            </div>
          </div>
        </Spin>
      )
    }
  }

  _sliderContainer() {
    let exhibitImageView = this.state.exhibitImageView, pageList = this.state.pageList, quality = this.state.archive ? this.state.archive.quality : '';
    var that = this
    var settings = {
      className: 'slider',
      dots: false,
      infinite: false,
      speed: 1,
      slidesToScroll: this.state.slickCount,
      slidesToShow: this.state.slickCount,
      beforeChange: function (currentSlide, nextSlide) {
        console.log('before change', currentSlide, nextSlide);
      },
      afterChange: function (currentSlide) {
        console.log(currentSlide)
      },
    };
    var exhibitImageStyle = {
      width: exhibitImageView.width,
      height: exhibitImageView.height,
      lineHeight: exhibitImageView.height + 'px'
    }
    return (
        <Slider {...settings} ref="slider">
          {this.state.showArray.map((item, index) => {
            if (index == 0) {
              return (
                <div key={index} style={{width: 80}} onClick={this.selectTemplate.bind(this, index)}>
                  <div className="image-box clearfix">
                    {this.state.frontPage ? <img src={this.state.frontPage.template.exhibit_image} className="file-img" style={exhibitImageStyle}/> : ''}
                    <div className="template-descrition">封面</div>
                   </div>
                </div>
              )
            } else {
              let pageLeft = pageList[(index - 1) * 2], pageRight = pageList[(index - 1) * 2 + 1];
              return (
                <div key={index} onClick={this.selectTemplate.bind(this, index)}>
                  <div className="image-box clearfix">
                    {pageLeft ? (pageLeft.id ?  <img src={pageLeft.template.exhibit_image} className="file-img" style={exhibitImageStyle}/> : <div className="no-template" style={exhibitImageStyle}>{(quality == 'paperback' && index == 1) ? '扉页' : '未添加'}</div>) : ''}
                    {pageRight ? (pageRight.id ?  <img src={pageRight.template.exhibit_image} className="file-img page-right" style={exhibitImageStyle}/> : <div className="no-template page-right" style={exhibitImageStyle}>未添加</div>) : ''}
                    <div className="template-descrition">{pageLeft ? (index == 1 && quality == 'paperback' ? '扉页' : pageLeft.page_number) : ''}{pageRight ?  ' - ' + pageRight.page_number: ''}</div>
                  </div>
                </div>
              )
            }
          })}
        </Slider>
    )
  }

  render() {
    return (
        <div className="archive-book-page">
          <div className="select-semester-box">
            <div className="student-name">{this.state.studentName}</div>
            <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester}>
              {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
            </Select>
          </div>
          {this.state.paid_status ? <div>
            {this.state.role.associatName=="system"?<div className="update-print" onClick={this.forceUpdate}>
              <div className="update-print-label">更新电子册</div>
            </div>:""}

            <div className="footer-print" onClick={this.confirmPrint}>
              <div className="footer-print-confirm-img"></div>
              <div className="footer-print-label">获取电子册</div>
              {/* <div className="footer-print-label complete-info">已完成{this.getReviewedPageCount()}/{this.getPageCount()}</div> */}
            </div>
            {this.state.archive ? this._showArchiveTemplateView() : ''}
            {!this.state.archive ? <div style={{ height: this.state.templateContainerView.height }} className="archive-template-container"></div> : ''}

            <div className="slider-container">

              <Icon type="caret-left" onClick={this.previous} className="caret-left caret-icon" />
              <Icon type="caret-right" onClick={this.next} className="caret-right caret-icon" />

              {this._sliderContainer()}
            </div>
          </div> : <div className="no-paid-semester">
            <div>学期未解锁</div>
            <div style={{ fontSize: '14px' }}>嘟嘟养成记小程序解锁该学期后可查看内容</div>
            <div><Button type="primary" onClick={() => this.setState({ showPayModal: true })}>去解锁</Button></div>
          </div>}

          <PayModal visible={this.state.showPayModal} studentId={this.state.role.associatObj.id} callbackPayModal={this.callbackPayModal.bind(this)} />
          {this._renderArchiveBookModal()}
        </div>
    )
  }
}




// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/ArchiveBookStudentDetailPage.jsx